import axios from 'axios';
import { currentHttpOptions } from '../common/utilities/utilitiesFunctions';

const BASE_URL = process.env.REACT_APP_DOTNET_URL;

/**
 * Workplan Service
 * Centralizes all workplan-related API calls
 */
export const workplanService = {
	/**
	 * Get all active workplans
	 * @returns {Promise} Axios promise with workplans data
	 */
	getWorkplans: () =>
		axios.get(`${BASE_URL}/api/v1/manager/Workplan/GetWorkplans`, currentHttpOptions()),

	/**
	 * Get archived workplans
	 * @returns {Promise} Axios promise with archived workplans data
	 */
	getArchivedWorkplans: () =>
		axios.get(`${BASE_URL}/api/v1/manager/Workplan/GetArchivedWorkplans`, currentHttpOptions()),

	/**
	 * Get settings for manager
	 * @returns {Promise} Axios promise with settings data
	 */
	getSettings: () =>
		axios.get(`${BASE_URL}/api/v1/admin/GetSettingsForManager`, currentHttpOptions()),

	/**
	 * Delete a workplan by ID
	 * @param {string} workplanId - The ID of the workplan to delete
	 * @returns {Promise} Axios promise
	 */
	deleteWorkplan: (workplanId) =>
		axios.delete(`${BASE_URL}/api/v1/manager/Workplan/DeleteWorkPlan/${workplanId}`, currentHttpOptions()),

	/**
	 * Archive a workplan by ID
	 * @param {string} workplanId - The ID of the workplan to archive
	 * @returns {Promise} Axios promise
	 */
	archiveWorkplan: (workplanId) =>
		axios.post(`${BASE_URL}/api/v1/manager/Workplan/ArchiveWorkplan/${workplanId}`, {}, currentHttpOptions()),

	/**
	 * Create a new workplan
	 * @param {Object} workplanData - The workplan data to create
	 * @returns {Promise} Axios promise
	 */
	createWorkplan: (workplanData) =>
		axios.post(`${BASE_URL}/api/v1/manager/Workplan/CreateWorkplan`, workplanData, currentHttpOptions()),

	/**
	 * Update an existing workplan
	 * @param {Object} workplanData - The updated workplan data (must include workplanId)
	 * @returns {Promise} Axios promise
	 */
	updateWorkplan: (workplanData) =>
		axios.post(`${BASE_URL}/api/v1/manager/Workplan/EditWorkplan`, workplanData, currentHttpOptions()),
};

